'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$123(ps$79) {
  this.a6L = null;
  this.a6L = ps$79;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$123 as $c_Lmealorama_jsonCodecs$package$$anon$123 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$123.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$123;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$123() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$123 as $h_Lmealorama_jsonCodecs$package$$anon$123 };
$h_Lmealorama_jsonCodecs$package$$anon$123.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6L.a.length;
});
$p.g = (function(i) {
  return this.a6L.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$123 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$123, "mealorama.jsonCodecs$package$$anon$123", ({
  Iy: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$123 as $d_Lmealorama_jsonCodecs$package$$anon$123 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$123.js.map
